import TableHeadCell from './TableHeadCell';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    color: '#1689FA',
  },
})(TableHeadCell);
